/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSalesInvoiceDto } from './GetSalesInvoiceDto';
import {
    GetSalesInvoiceDtoFromJSON,
    GetSalesInvoiceDtoFromJSONTyped,
    GetSalesInvoiceDtoToJSON,
} from './GetSalesInvoiceDto';
import type { GetInvoicePaymentDto } from './GetInvoicePaymentDto';
import {
    GetInvoicePaymentDtoFromJSON,
    GetInvoicePaymentDtoFromJSONTyped,
    GetInvoicePaymentDtoToJSON,
} from './GetInvoicePaymentDto';

/**
 * 
 * @export
 * @interface GetInvoicePaymentLinkDto
 */
export interface GetInvoicePaymentLinkDto {
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentLinkDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentLinkDto
     */
    type: GetInvoicePaymentLinkDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentLinkDto
     */
    invoicePaymentId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetInvoicePaymentLinkDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentLinkDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentLinkDto
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentLinkDto
     */
    receiptId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentLinkDto
     */
    salesInvoiceTotalLinkedAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentLinkDto
     */
    salesInvoiceUnlinkedAmount?: string | null;
    /**
     * 
     * @type {GetSalesInvoiceDto}
     * @memberof GetInvoicePaymentLinkDto
     */
    salesInvoice?: GetSalesInvoiceDto | null;
    /**
     * 
     * @type {GetSalesInvoiceDto}
     * @memberof GetInvoicePaymentLinkDto
     */
    correctionInvoice?: GetSalesInvoiceDto | null;
    /**
     * 
     * @type {GetInvoicePaymentDto}
     * @memberof GetInvoicePaymentLinkDto
     */
    invoicePayment?: GetInvoicePaymentDto | null;
}


/**
 * @export
 */
export const GetInvoicePaymentLinkDtoTypeEnum = {
    Invoice: 'Invoice',
    Withdrawal: 'Withdrawal',
    Return: 'Return',
    Correction: 'Correction'
} as const;
export type GetInvoicePaymentLinkDtoTypeEnum = typeof GetInvoicePaymentLinkDtoTypeEnum[keyof typeof GetInvoicePaymentLinkDtoTypeEnum];


/**
 * Check if a given object implements the GetInvoicePaymentLinkDto interface.
 */
export function instanceOfGetInvoicePaymentLinkDto(value: object): value is GetInvoicePaymentLinkDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetInvoicePaymentLinkDtoFromJSON(json: any): GetInvoicePaymentLinkDto {
    return GetInvoicePaymentLinkDtoFromJSONTyped(json, false);
}

export function GetInvoicePaymentLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoicePaymentLinkDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'invoicePaymentId': json['invoicePaymentId'] == null ? undefined : json['invoicePaymentId'],
        'active': json['active'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'receiptId': json['receiptId'] == null ? undefined : json['receiptId'],
        'salesInvoiceTotalLinkedAmount': json['salesInvoiceTotalLinkedAmount'] == null ? undefined : json['salesInvoiceTotalLinkedAmount'],
        'salesInvoiceUnlinkedAmount': json['salesInvoiceUnlinkedAmount'] == null ? undefined : json['salesInvoiceUnlinkedAmount'],
        'salesInvoice': json['salesInvoice'] == null ? undefined : GetSalesInvoiceDtoFromJSON(json['salesInvoice']),
        'correctionInvoice': json['correctionInvoice'] == null ? undefined : GetSalesInvoiceDtoFromJSON(json['correctionInvoice']),
        'invoicePayment': json['invoicePayment'] == null ? undefined : GetInvoicePaymentDtoFromJSON(json['invoicePayment']),
    };
}

export function GetInvoicePaymentLinkDtoToJSON(value?: GetInvoicePaymentLinkDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'invoicePaymentId': value['invoicePaymentId'],
        'active': value['active'],
        'amount': value['amount'],
        'comment': value['comment'],
        'receiptId': value['receiptId'],
        'salesInvoiceTotalLinkedAmount': value['salesInvoiceTotalLinkedAmount'],
        'salesInvoiceUnlinkedAmount': value['salesInvoiceUnlinkedAmount'],
        'salesInvoice': GetSalesInvoiceDtoToJSON(value['salesInvoice']),
        'correctionInvoice': GetSalesInvoiceDtoToJSON(value['correctionInvoice']),
        'invoicePayment': GetInvoicePaymentDtoToJSON(value['invoicePayment']),
    };
}

